import styles from './BenefitSection.module.css';

const benefitCards = [
  {
    cardTitle: '무료',
    discMain: '첫 2회 무료체험',
    discSub: '라파엘노인데이케어센터',
    discSub2 : '사회공헌 지원',
    discAccent: null,
  },
  {
    cardTitle: '할인',
    discMain: '안심체험 3,000원',
    discSub: '3~4회',
    discSub2: '정상가 16,000원 대비',
    discAccent: '80% 할인',
  },
];

function BenefitSection() {
  return (
    <section className={styles.benefitContainer}>
      <h2 className={styles.title}>이벤트 혜택</h2>
      <div className={styles.cardContainer}>
        {benefitCards.map((card) => (
          <div key={card.cardTitle} className={styles.card}>
            <div className={styles.cardTitle}>{card.cardTitle}</div>
            <div className={styles.discWrapper}>
              <p className={styles.discMain}>{card.discMain}</p>
              <p className={styles.discSub}>{card.discSub}</p>
              <p className={styles.discSub2}>{card.discSub2}</p>
              {card.discAccent && (
                <p className={styles.discAccent}>{card.discAccent}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default BenefitSection;
